import { defineComponent as _defineComponent } from 'vue'
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import useOfferSorting from '@/components/calculator/results/OfferSorting';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationToolbarSort',
  setup(__props) {

const {sortItems,} = useOfferSorting();
const store = useSimulationStore();


return { __sfc: true,sortItems, store, I18NGetter }
}

})